export const PAYEE_ID_PARAM = 'payee_id';

export const PAYEE_LIST_ERROR_TOAST_MESSAGE_KEY =
  'payee-list-error-toast-message';
export const PAYEE_LIST_SUCCESS_TOAST_MESSAGE_KEY =
  'payee-list-success-toast-message';
